import script from "./ThButton.vue?vue&type=script&setup=true&lang=js"
export * from "./ThButton.vue?vue&type=script&setup=true&lang=js"

import "./ThButton.vue?vue&type=style&index=0&id=141bd36b&scoped=true&lang=css"

import exportComponent from "E:\\code\\软著项目\\software\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-141bd36b"]])

export default __exports__